import { KojinResult } from 'interface/kojin'
import { useState, useCallback } from 'react'

export const useKojinPreviewDialog = () => {
	const [kojinList, setKojinList] = useState<KojinResult[]>([])
	const [kojinCode, setKojinCode] = useState<string | null>(null)
	const [authorId, setAuthorId] = useState<number | null>(null)

	const openKojin = useCallback(
		(kojinCode: string | null) => {
			setAuthorId(null)
			setKojinCode(kojinCode)
		},
		[setKojinCode, setAuthorId]
	)
	const openAuthor = useCallback(
		(authorId: number | null) => {
			setKojinCode(null)
			setAuthorId(authorId)
		},
		[setKojinCode, setAuthorId]
	)
	const close = useCallback(
		() => openKojin(null),
		[openKojin]
	)
	return {
		kojinList,
		kojinCode,
		authorId,
		setKojinList,
		openKojin,
		openAuthor,
		close
	}
}